import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { setupDateInputLocale } from './utils/dateInputLocale';
import Dashboard from './pages/dashboard/Dashboard';
import ChartOfAccounts from './pages/master/ChartOfAccounts';
import Customers from './pages/master/Customers';
import Vendors from './pages/master/Vendors';
import Items from './pages/master/Items';
import Employees from './pages/master/Employees';
import BankAccounts from './pages/master/BankAccounts';
import SalesQuotations from './pages/sales/SalesQuotations';
import SalesOrders from './pages/sales/SalesOrders';
import DeliveryReceipts from './pages/sales/DeliveryReceipts';
import SalesInvoices from './pages/sales/SalesInvoices';
import Collections from './pages/sales/Collections';
import ARAgingReport from './pages/sales/ARAgingReport';
import PurchaseOrders from './pages/purchases/PurchaseOrders';
import GoodsReceipt from './pages/purchases/GoodsReceipt';
import PurchaseInvoices from './pages/purchases/PurchaseInvoices';
import Payments from './pages/purchases/Payments';
import APAgingReport from './pages/purchases/APAgingReport';
import StockStatus from './pages/inventory/StockStatus';
import StockTransactions from './pages/inventory/StockTransactions';
import StockAdjustment from './pages/inventory/StockAdjustment';
import BillOfMaterials from './pages/inventory/BillOfMaterials';
import JournalEntry from './pages/gl/JournalEntry';
import BankReconciliation from './pages/gl/BankReconciliation';
import FinancialStatements from './pages/gl/FinancialStatements';
import Timekeeping from './pages/payroll/Timekeeping';
import PayrollProcessing from './pages/payroll/PayrollProcessing';
import PayrollRegister from './pages/payroll/PayrollRegister';
import GovernmentReports from './pages/payroll/GovernmentReports';
import SalesReports from './pages/reports/SalesReports';
import ExpenseReports from './pages/reports/ExpenseReports';
import TaxReports from './pages/reports/TaxReports';
import GeneralLedgerReports from './pages/reports/GeneralLedgerReports';
import UserManagement from './pages/settings/UserManagement';
import CompanyProfile from './pages/settings/CompanyProfile';
import FiscalYearSetup from './pages/settings/FiscalYearSetup';
import MenuSetup from './pages/settings/MenuSetup';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

function App() {
  useEffect(() => {
    setupDateInputLocale();
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/master/accounts" element={<ChartOfAccounts />} />
        <Route path="/master/customers" element={<Customers />} />
        <Route path="/master/vendors" element={<Vendors />} />
        <Route path="/master/items" element={<Items />} />
        <Route path="/master/employees" element={<Employees />} />
        <Route path="/master/bank-accounts" element={<BankAccounts />} />
        <Route path="/sales/quotations" element={<SalesQuotations />} />
        <Route path="/sales/orders" element={<SalesOrders />} />
        <Route path="/sales/deliveries" element={<DeliveryReceipts />} />
        <Route path="/sales/invoices" element={<SalesInvoices />} />
        <Route path="/sales/collections" element={<Collections />} />
        <Route path="/sales/ar-aging" element={<ARAgingReport />} />
        <Route path="/purchases/orders" element={<PurchaseOrders />} />
        <Route path="/purchases/receipts" element={<GoodsReceipt />} />
        <Route path="/purchases/invoices" element={<PurchaseInvoices />} />
        <Route path="/purchases/payments" element={<Payments />} />
        <Route path="/purchases/ap-aging" element={<APAgingReport />} />
        <Route path="/inventory/status" element={<StockStatus />} />
        <Route path="/inventory/transactions" element={<StockTransactions />} />
        <Route path="/inventory/adjustment" element={<StockAdjustment />} />
        <Route path="/inventory/bom" element={<BillOfMaterials />} />
        <Route path="/gl/journal-entry" element={<JournalEntry />} />
        <Route path="/gl/bank-reconciliation" element={<BankReconciliation />} />
        <Route path="/gl/statements" element={<FinancialStatements />} />
        <Route path="/payroll/timekeeping" element={<Timekeeping />} />
        <Route path="/payroll/processing" element={<PayrollProcessing />} />
        <Route path="/payroll/register" element={<PayrollRegister />} />
        <Route path="/payroll/gov-reports" element={<GovernmentReports />} />
        <Route path="/reports/sales" element={<SalesReports />} />
        <Route path="/reports/expense" element={<ExpenseReports />} />
        <Route path="/reports/tax" element={<TaxReports />} />
        <Route path="/reports/gl" element={<GeneralLedgerReports />} />
        <Route path="/settings/users" element={<UserManagement />} />
        <Route path="/settings/company" element={<CompanyProfile />} />
        <Route path="/settings/fiscal-year" element={<FiscalYearSetup />} />
        <Route path="/settings/menu" element={<MenuSetup />} />
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
